// Didascalie della chiamata di prova, dagli eventi del data channel WebRTC.
// Stessa logica dei turni del gateway: i delta non segnano la fine di un turno,
// si apre una bolla nuova su un salto della timeline. Full duplex: si allunga
// l'ultima bolla DELLO STESSO parlante, non l'ultima in assoluto.
const GAP_MS = 1500;
const ROLE_BY_TYPE = {
  'session.input_transcript.delta': 'user',
  'session.output_transcript.delta': 'assistant',
};

export function reduceCaption(captions, event) {
  const role = ROLE_BY_TYPE[event?.type];
  if (!role || typeof event.delta !== 'string' || !event.delta) return captions;
  const start = Number(event.start_ms) || 0;
  const end = Number(event.end_ms) || start;
  let idx = -1;
  for (let i = captions.length - 1; i >= 0; i--) if (captions[i].role === role) { idx = i; break; }
  const last = idx >= 0 ? captions[idx] : null;
  if (last && start - last.endMs <= GAP_MS) {
    const next = captions.slice();
    next[idx] = { ...last, text: last.text + event.delta, endMs: Math.max(last.endMs, end) };
    return next;
  }
  return [...captions, { role, text: event.delta, startMs: start, endMs: end }];
}
